import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceIndicator = ({ compliance, checking = false }) => {
  if (checking) {
    return (
      <div className="flex items-center gap-2">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
        <span className="text-xs text-primary">Checking...</span>
      </div>
    );
  }

  if (compliance.compliant) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-success rounded-full flex items-center justify-center">
          <Icon name="Check" size={10} color="white" />
        </div>
        <span className="text-xs text-success font-medium">Compliant</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <div className="w-4 h-4 bg-error rounded-full flex items-center justify-center">
        <Icon name="X" size={10} color="white" />
      </div>
      <span className="text-xs text-error font-medium">Issues Found</span>
    </div>
  );
};

export default ComplianceIndicator;
